import React, { useState, useEffect, useCallback } from 'react';
import Navbar from '../../../ReusableBlocks/Navbar';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import ResetFlow from '../../../Images/reset-flow-image-2.png';
import Loading_Scren from '../../../ReusableBlocks/Loading_Screen';
import LoadingBar from '../../../Images/Animation - 1710409471189.json';
import SuccessBar from '../../../Images/Done.json';
import { useSelector, useDispatch } from 'react-redux';
import { fetchResetOperations } from '../../../Redux/Dashboard/External/Reset/ResetPageAction';
import { performReset, resetOnSuccess } from '../../../Redux/Dashboard/External/Demo_Catalgue/ResetAction';
import Swal from 'sweetalert2';
import * as PATH from '../../../CentralisedLink';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import SuccesScreen from '../../../ReusableBlocks/SuccesMessage';
import ResetTenantDropdown from '../../../ReusableBlocks/ResetTenantDropdown';

const Reset_Demo = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();


  // const { resetOperations, userTenant, userTempTenant } = useSelector((state) => state.ResetPageContent);
  const resetPageContent = useSelector((state) => state.ResetPageContent || {});
  const resetOperations = Array.isArray(resetPageContent.resetOperations)
    ? resetPageContent.resetOperations
    : [];

  const safeUserTenants = Array.isArray(resetPageContent.userTenants)
    ? resetPageContent.userTenants
    : [];


  const isLoading = useSelector(state => state.ResetPageContent?.loading);
  const error = useSelector(state => state.ResetPageContent?.error);

  const isLoadingReset = useSelector(state => state.Reset?.loading);
  const errorMessageReset = useSelector(state => state.Reset?.error);
  const onSuccesReset = useSelector(state => state.Reset?.onSucces);

  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const [loadingAnimation, setLoadingAnimation] = useState(LoadingBar);
  const [url, setUrl] = useState('');
  const [vsibilty, setVsibilty] = useState('-none');
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [selectedTenantKey, setSelectedTenantKey] = useState("");
  const [selectedTenantDetails, setSelectedTenantDetails] = useState(null);

  const [resetName, setResetName] = useState("");
  const [onSuccesResetLoading, setOnSuccesResetLoading] = useState(false);
  const [SuccessAnimation, setSuccessAnimation] = useState(SuccessBar);
  const [SucsessTitle, setSucsessTitle] = useState('');
  const [RedirectingUrl, setRedirectingUrl] = useState('dash/catalogue');
  const [noTenantsMessage, setNoTenantsMessage] = useState('');


  useEffect(() => {
    return () => {
      // Dispatch action to clear the error when the component unmounts or modal closes
      dispatch(resetOnSuccess());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchResetOperations());
    dispatch(resetOnSuccess());
    return () => {
      setOnSuccesResetLoading(false);
    };
  }, [dispatch]);

  useEffect(() => {
    if (onSuccesReset) {
      setOnSuccesResetLoading(true);
      setSucsessTitle("Successful");
    } else {
      setOnSuccesResetLoading(false);
    }
  }, [onSuccesReset]);

  useEffect(() => {
    if (error && error !== 'You have not completed mandatory Tech Central Training, please complete it.') {
      Swal.fire({
        title: 'Error',
        text: error,
        icon: 'error',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [error]);

  useEffect(() => {
    if (errorMessageReset) {
      Swal.fire({
        title: 'Error',
        text: errorMessageReset,
        icon: 'error',
        confirmButtonText: 'Retry',
        showCancelButton: true,
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      });
    }
  }, [errorMessageReset]);



  const tenantOptionsv2 = React.useMemo(() => {
    return safeUserTenants
      .filter((t) => t?.['BHOM URL'])
      .map((t, idx) => {
        const url = t['BHOM URL'];
        const type = (t?.type || '').toLowerCase(); // booked | user

        return {
          value: `${url}__${type || 'user'}__${idx}`,
          url,
          rawType: type,
          details: t, // pass this to performReset (legacy keys)
        };
      });
  }, [safeUserTenants]);

  useEffect(() => {
    // Auto-pick first tenant when list becomes available
    if (!tenantOptionsv2.length) return;

    // If already selected and still valid, keep it
    const stillValid = tenantOptionsv2.some(o => o.value === selectedTenantKey);
    if (stillValid) return;

    // Otherwise select the first
    const first = tenantOptionsv2[0];
    setSelectedTenantKey(first.value);
    setSelectedTenantDetails(first.details);
  }, [tenantOptionsv2, selectedTenantKey]);


  const tenantDropdownOptions = React.useMemo(() => {
    return tenantOptionsv2.map((opt) => ({
      value: opt.value,          // internal unique key
      displayUrl: opt.url,       // real BHOM URL shown in UI
      type: opt.rawType || "user"
    }));
  }, [tenantOptionsv2]);



  const handleClickReset = useCallback(() => {
    if (!selectedTenantDetails) {
      alert("Please select a tenant.");
      return;
    }

    dispatch(performReset(resetName, selectedTenantDetails));
  }, [selectedTenantDetails, resetName, dispatch]);

  const handleShowWhatsNew = (title, description) => {
    setShowWhatsNew(true);
    setModalTitle(title);
    setModalDescription(description);
    setResetName(title);
  };

  const handleCloseWhatsNew = () => {
    setShowWhatsNew(false);
    setOnSuccesResetLoading(false);
  };

  const handleTenantChange = (selectedValue) => {
    setSelectedTenantKey(selectedValue);

    const found = tenantOptionsv2.find(o => o.value === selectedValue);
    setSelectedTenantDetails(found ? found.details : null);
  };

  const handleCloseLoading = () => {
    setLoadingAnimation(LoadingBar);
    handleCloseWhatsNew();
  };

  const succesMessageClose = () => {
    setOnSuccesResetLoading(false);
    handleCloseWhatsNew();
    window.location.reload();
  };

  const SucessHandleLoadingRedirect = () => {
    setOnSuccesResetLoading(false);
    navigate(`${PATH.DEMO_CATALGUE_PATH}`);
  }

    useEffect(() => {
    if (tenantOptionsv2.length === 0) setNoTenantsMessage('You need at least one tenant to proceed.');
    else setNoTenantsMessage('');
  }, [tenantOptionsv2]);

  return (
    <>
      {isLoading && <LoadingScreen text="Loading..." />}

      {isLoadingReset && (
        <Loading_Scren
          LoadingAnimation={loadingAnimation}
          LoadingTitle={<span><strong>{resetName}</strong> In Progress</span>}
          url={url}
          vsibilty={vsibilty}
          handlecloseloading={handleCloseLoading}
        />
      )}

      {onSuccesResetLoading && (
        <SuccesScreen
          SuccessAnimation={SuccessAnimation}
          SucsessTitle={<span>Successfully Ran <strong>{resetName}</strong></span>}
          SucessHandleLoadingRedirect={SucessHandleLoadingRedirect}
          SucessHandleLoading={succesMessageClose}
        />
      )}

      <Navbar activeTab={"RESET_DEMO"} />

      <div className='reset-demo-background'>
        <div className='container'>
          <br />
          <br />

          <h1 className='hot-res-h1'>What operation would you like to perform?</h1>
          <p className='hot-res-p'>A carefully selected compilation of demos that have garnered widespread popularity</p>
          <br />
          <div className="row mt-10 mb-10">
            {resetOperations.map((operation, index) => {
              const cardClassName = index === 1 ? 'reset-card-one-black' : 'reset-card-one';
              return (
                <div className="col-md-6 col-lg-4" key={index}>
                  <div className={cardClassName} onClick={() => handleShowWhatsNew(operation.title, operation.description)}>
                    <h1 className='reset-card-h1'>{operation.title}</h1>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </div>

      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showWhatsNew}
        fullscreen={false}
      >
        <Modal.Body className='reset-modal'>
          <div className="containe">
            <h1 className='reset-modal-hl'>{modalTitle}</h1>
            <img src={ResetFlow} className='reset-flow-img' alt="Reset Flow" />

            <div className='list-main-div'>
              <ul className='list-main-ul' dangerouslySetInnerHTML={{ __html: modalDescription }} />
            </div>

            <div className='select-tenamt'>
              {noTenantsMessage ? (
                <>
                  <center><p className='tenent-warning'>{noTenantsMessage}</p></center>
                  <center>
                    <button className='reset-btn-cancel-on' onClick={handleCloseWhatsNew}>Cancel</button>
                  </center>
                </>
              ) : (
                <>
                 <label className="reset-tenant-label">Select a tenant</label>
                   <ResetTenantDropdown
                    options={tenantDropdownOptions}
                    value={selectedTenantKey}
                    onChange={handleTenantChange}
                    disabled={tenantDropdownOptions.length === 0}
                  />

                  <br />

                  <div className='reset-modal-btn-div'>
                    <button className='reset-btn-cancel' onClick={handleCloseWhatsNew}>Cancel</button>
                    <button className='reset-btn-procceed' onClick={handleClickReset}>
                      Proceed To Reset <span className='left-arrow-sty'><i className="fa-solid fa-arrow-right"></i></span>
                    </button>
                  </div>
                  <br></br>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Reset_Demo;
